<template>
    <p style="width:100%" class="ql-editor">
        <span :class="btn.css" :style="{ fontSize: btn.fontSize+'px', lineHeight: btn.lineHeight, textAlign: btn.textAlign, backgroundColor: btn.backgroundColor, color: btn.fontColor }" style="width: 100%;" v-html="btn.html"></span>
    </p>
</template>

<script>

import { mapMutations } from 'vuex'
import WebSoc from '@/utils/WebSoc.js';

export default {
    props: ['btn'],
    computed: {
        quills () { return this.$store.state.quills },
        client_id () { return this.$store.state.client_id },
    },
    mounted () {
        var quill_id = this.btn.quill_id;
        var quill = this.quills.find(q => q._id == quill_id);
        if ( quill ) return this.quill = quill;
        WebSoc.SEND({ t: 'getQuill', data: { quill_id: this.quill_id, client_id: this.client_id }},quill => {
            this.quill = quill;
            this.saveQuill(quill);
        });
    },
    methods: {
        ...mapMutations([
            'saveQuill'
        ])
    }
}    
</script>